import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class CoachPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.coachRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.coachImport,
    );
    this.coachAutocomplete = permissionChecker.match(
      Permissions.values.coachAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.coachCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.coachEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.coachDestroy,
    );
  }
}
